import IconErrorSolid from '@apollo/icons/small/IconErrorSolid.svg';
import { Badge, forwardRef } from '@apollo/orbit';
import React from 'react';

type Props = { hasErrors: boolean; version?: string | null };
export const FederatedGraphBadge = forwardRef<Props, 'span'>(
  ({ version, hasErrors }, ref) => {
    return (
      <Badge
        variant={hasErrors ? 'error' : 'neutralOutlined'}
        ref={ref}
        icon={hasErrors ? <IconErrorSolid /> : undefined}
      >
        Federated {version && <span className="lowercase">| v{version}</span>}
      </Badge>
    );
  },
);
